<template>
  <section ref="root" class="grid-cards wrapper">
    <div ref="wrapper" class="grid-cards-inner">
      <Card
        v-for="(item, index) in content"
        :key="`menu-main-secondary-${index}`"
        :content="item"
      />
    </div>
  </section>
</template>

<script lang="ts">
import type { Card as CardType } from '@/types'
</script>

<script setup lang="ts">
import { ref } from 'vue'

import Card from '@/components/cards/Default.vue'

import type { PropType } from 'vue'

const wrapper = ref()
const root = ref<HTMLElement>()

defineProps({
  content: {
    type: Array as PropType<CardType[]>,
    required: true,
  },
  type: {
    type: String,
    default: 'news',
  },
})
</script>

<style lang="scss" scoped>
.grid-cards-inner {
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.8rem;
  row-gap: 3.6rem;

  @include mq(s) {
    grid-template-columns: repeat(2, 1fr);
  }
}

:deep(.card__picture) {
  aspect-ratio: 80/62;
}
</style>
